
export default {
  productData: {
    serialNumber: 'DA-HMUL-004',
    name: 'Holzbalkendecken mit Unterdecken an Lattung | Aufbau 4',
    construction: {
      composition: [
        {
          type: 'screed',
          title: { de: 'Zementgebundene Spanplatte ZSP oder Gipsfaserplatte GF' },
          output: '≥ 22',
          value: 'd-22'
        },
        {
          type: 'insulation',
          title: { de: 'Mineralwolledämmplatte MW<br>(<i>s‘</i> ≤ 30 MN/m<sup>3</sup>; Anwendungsgebiet DES-sm)' },
          output: '≥ 20',
          value: 'm-20'
        },
        {
          type: 'fill',
          title: { de: 'Mit StoPrefa Coll SB gebundene Schüttung (<i>m‘</i> ≥ 90 kg/m<sup>2</sup>), ggf. Rieselschutz' },
          output: '≥ 60',
          value: 'scsb-60'
        },
        {
          type: 'woodenPanel',
          title: { de: 'Holzwerkstoffplatte HW' },
          output: '22',
          value: 22
        },
        {
          type: 'supportingStructure',
          title: { de: 'Balken oder Stegträger' },
          output: '220',
          value: 'bs-220'
        },
        {
          type: 'suspendedCeiling',
          title: { de: 'Hohlraumdämpfung' },
          output: '100',
          value: 'h-100'
        },
        {
          type: 'suspendedCeiling',
          title: { de: 'Lattung' },
          output: '24',
          value: 'ba-24'
        },
        {
          type: 'suspendedCeiling',
          title: { de: 'Gipsplatte GK' },
          output: '12,5',
          value: 'g-12.5'
        }
      ],
      sum: {
        output: '380,5', value: 380.5
      }
    },
    technicalValues: {
      impactSoundLevel: { // L,nw
        output: '55 (2)', value: 55
      },
      soundReductionIndex: { // Rw
        output: '61 (-6; -13)', value: 61
      },
      heatTransferCoefficient: { // U-Wert
        output: '0,25', value: 0.25
      },
      fireResistance: {
        output: 'F 30-B',
        value: 'F-30-B'
      },
      massPerUnitArea: {
        output: '167.3 [kg/m²]'
      }
    }
  },
  image: 'da-hmul-004.png',
  pdf: 'Holzbalkendecken-mit-Unterdecke-an-Lattung-Aufbau-4-DA-HMUL-004-Rev03.pdf'
}
